import _ from "lodash";
import moment from "moment";
import { PointMap } from "../../../gateway/CalculatingMachineV2Gateway/PointMap";
import { Dashboard } from "../../../gateway/Dashboard/Dashboard";
import { Department } from "../../../gateway/Department/Department";
import { Visualization } from "../../../gateway/Visualization/Visualization";
import { getDate } from "../../../utils/date/date";

export class DepartmentTaxAndPersonnel {
    constructor({ Serie, CalculatingMachine } = {}) {
        this.Dashboard = new Dashboard();
        this.Serie = Serie;
        this.CalculatingMachine = CalculatingMachine;
        this.Visualization = new Visualization();
        this.Department = new Department(
            this.Dashboard,
            Serie,
            this.Visualization
        );
    }

    setSource(source) {
        this.source = source;
    }

    /**
     * @public
     * Retorna valor de um point
     * @param {Object} param0
     * @returns
     */
    getPoint({ pointsMap, time, serie, source, scenarioId = "ORIGINAL" }) {
        const point = PointMap.findPoint(
            pointsMap,
            serie,
            scenarioId,
            "monthly",
            getDate(time)
        );

        if (source == "accounting") {
            let isAccountResult =
                source === "accounting" &&
                parseInt(_.get(serie, "classifier", "").toString().charAt(0)) >=
                    3;

            if (isAccountResult) {
                return (
                    _.get(point, "m.v") ||
                    _.get(point, "m.f", 0) - _.get(point, "m.o", 0)
                );
            } else {
                return _.get(point, "m.f", _.get(point, "m.v", 0));
            }
        }

        return _.get(point, "m.v", 0);
    }

    /**
     * @public
     * Retorna valor de um point
     * @param {Object} param0
     * @returns {Object} { series e poinds }
     */
    getSeriesAndPoints({ companyId }) {
        let series = this.Serie.findCollection(
            {
                companyId: companyId,
                sources: this.source,
                "metadata.editMode": true
            },
            {},
            "array"
        );
        series = this.organizeClassifiers(series);
        this.CalculatingMachine.setSource(this.source);

        const pointsResult = this.CalculatingMachine.result({
            companyId: companyId,
            serieIds: series.map((serie) => serie._id),
            scenario: "ORIGINAL",
            period: "monthly",
            options: { recalculate: true, filterProjectionPoints: true }
        });
        return { series, points: pointsResult };
    }

    _organizeClassifiersNew(series) {
        const result = series.map((s) => {
            const firstChars = s.classifier.slice(0, 3);
            const firstNumber = Number(firstChars.replaceAll(".", 0));

            const secondChars = s.classifier.slice(3);

            if (!secondChars)
                return {
                    ...s,
                    newClassifier: firstNumber
                };

            const secondNumber = secondChars.replaceAll(".", 0);

            let replaced = secondNumber;

            const length = secondNumber.length;

            const lastChar = secondNumber.charAt(length - 1);

            if (lastChar === "0")
                replaced =
                    secondNumber.substring(0, length - 1) +
                    "1" +
                    secondNumber.substring(length);

            return {
                ...s,
                newClassifier: Number(`${firstNumber}.${replaced}`)
            };
        });

        const sorted = _.sortBy(result, "newClassifier");

        return sorted;
    }

    splitterClassifier(a) {
        if (!a) return "999";

        let splitted = a.split(".");
        let splittedChar = splitted.map((split) => String.fromCharCode(split));
        return splittedChar.join(".");
    }

    organizeBreno(series) {
        const result = series.map((s) => {
            return {
                ...s,
                newClassifier: this.splitterClassifier(s.classifier)
            };
        });

        const sorted = _.sortBy(result, "newClassifier");

        return sorted;
    }

    organizeOld(seriesToOrganize) {
        const series = angular.copy(seriesToOrganize);

        const seriesAll = series.filter((s) => !s.removed);
        const seriesRemoved = series.filter((s) => s.removed);

        let masterSeries = [];

        const parentSeries = [];

        const _isFloat = (n) => {
            return Number(n) === n && n % 1 !== 0;
        };
        //organiza os pais
        seriesAll.forEach((masterSerie) => {
            if (!masterSerie.referenceId) {
                masterSeries.push(masterSerie);
            }
        });

        masterSeries = masterSeries.map((masterSerie, index) => {
            masterSerie.order = masterSerie.classifier
                ? parseInt(masterSerie.classifier.split(".")[1])
                : index;

            return masterSerie;
        });

        masterSeries = _.sortBy(masterSeries, "order");

        //para cada pai vamos decendo mais fundo
        masterSeries.forEach((masteerSerie, index) => {
            const _changeCompound = (masteerSerie) => {
                const seriesCompound = seriesAll.filter((s) => {
                    return masteerSerie.compound.includes(s._id);
                });

                seriesCompound.forEach((serieCompound, indexCompound) => {
                    serieCompound.classifier =
                        serieCompound.classifier ||
                        `${masteerSerie.classifier}.${
                            seriesCompound.length - 1
                        }`;

                    let lastClassifer = serieCompound.classifier;

                    lastClassifer = lastClassifer[lastClassifer.length - 1];

                    serieCompound.order = !_isFloat(masteerSerie.order)
                        ? Number(`${masteerSerie.order}.${lastClassifer}`)
                        : Number(`${masteerSerie.order}${lastClassifer}`);

                    parentSeries.push(serieCompound);

                    if (serieCompound.compound) {
                        _changeCompound(serieCompound);
                    }
                });
            };

            if (masteerSerie.compound) {
                _changeCompound(masteerSerie);
            }
        });

        const result = [...masterSeries, ...parentSeries, ...seriesRemoved];

        return _.sortBy(result, "order");
    }

    organizeClassifiers(seriesToOrganize) {
        return this.organizeBreno(seriesToOrganize);
    }

    departmentFactory({
        level,
        companyId,
        accountingId,
        referenceId,
        unit,
        serie
    } = {}) {
        let serieDocumentTemplate = {};
        if (level == "0") {
            // const serieDepartmentCount = this.Serie.countCollection({
            //     companyId,
            //     sources: this.source,
            //     $or: [{ level: "0" }, { level: 0 }]
            // });

            const serieDepartmentCount = this.Serie.findCollection({
                companyId,
                sources: this.source,
                $or: [{ level: "0" }, { level: 0 }]
            });
            const seriesList = serieDepartmentCount?.list || [];
            const classifiers = seriesList
                .map((s) => {
                    if (!s.classifier) return false;
                    const classifiers = s.classifier.split(".");
                    const lastClassifier = classifiers[1];
                    return Number(lastClassifier);
                })
                .filter((s) => s);
            const maxClassifier = classifiers.length ? _.max(classifiers) : 0;
            serieDocumentTemplate = {
                classifier_nz: `1${maxClassifier + 1}`,
                classifier: `1.${maxClassifier + 1}`,
                highlight: {
                    bold: true,
                    lineColor: true
                }
            };
        } else {
            const compounds = serie.compound || [];
            const seriesCompounds = this.Serie.findCollection({
                _id: { $in: compounds }
            });
            const seriesList = seriesCompounds?.list || [];
            const classifiers = seriesList.map((s) => {
                const classifiers = s.classifier.split(".");
                const lastClassifier = _.last(classifiers);
                return Number(lastClassifier);
            });
            const maxClassifier = classifiers.length ? _.max(classifiers) : 0;
            serieDocumentTemplate = {
                classifier_nz: `${serie.classifier}.${maxClassifier + 1}`,
                classifier: `${serie.classifier}.${maxClassifier + 1}`
            };
        }

        const serieDocumentObject = {
            referenceId: serie._id,
            name: "",
            unit: unit || "currency",
            genus: "synthetic",
            type: "raw",
            companyId,
            accountingId,
            ...serieDocumentTemplate,
            level,
            sources: [this.source],
            public: false,
            metadata: {
                editMode: true,
                disabled: false,
                showChart: true
            }
        };

        if (!serieDocumentObject.referenceId)
            delete serieDocumentObject.referenceId;

        return serieDocumentObject;
    }

    async insertDepartmentSerie({ serie, referenceId } = {}) {
        serie.referenceId = referenceId;
        const response = await this.Serie.save(serie, {
            department: true
        });

        await this.Serie.populateDepartament({
            companyId: serie.companyId,
            source: serie.sources[0]
        });

        return response;
    }

    getSeriesAndPointsCalculated({ companyId }) {
        const response = this.getSeriesAndPoints({
            companyId: companyId
        });

        const series = response.series;

        let responsePoints = this._consolidatePointsInSeries(
            PointMap.generateMap(response.points),
            series
        );

        responsePoints = this._recalculateSeriePoint(responsePoints, series);

        return {
            points: responsePoints,
            series: series
        };
    }

    _consolidatePointsInSeries(pointsMap, series, reset) {
        const responsePoints = {};

        const currentYear = new Date().getUTCFullYear();
        const years = this._generateYears(2010, currentYear);

        const months = [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez"
        ];

        series.forEach((serie) => {
            years.forEach((year) => {
                months.forEach((month, index) => {
                    const date = moment(`${year}-${index + 1}-01`)
                        .utcOffset(0)
                        .startOf("month")
                        .format();

                    let point = 0;
                    if (!reset) {
                        point = this.getPoint({
                            pointsMap,
                            time: date,
                            serie
                        });
                    }

                    _.set(
                        responsePoints,
                        `[${serie._id}][${year}-${index + 1}]`,
                        point || 0
                    );
                });
            });
        });

        return responsePoints;
    }

    _recalculateSeriePoint(points, series) {
        const _recursiveCalculate = (serie, date, series) => {
            let total = 0;
            if (serie.compound && serie.type !== "raw") {
                serie.compound.forEach((compound) => {
                    const serieCompound = series.find(
                        (s) =>
                            s._id === compound &&
                            !s.metadata.disabled &&
                            !s.removed
                    );

                    if (serieCompound)
                        total += _recursiveCalculate(
                            serieCompound,
                            date,
                            series
                        );
                });
            } else if (
                !serie.compound &&
                serie.type === "raw" &&
                !serie.metadata.disabled &&
                !serie.metadata.removed
            ) {
                return points[serie._id][date];
            } else if (
                serie.compound &&
                serie.type === "raw" &&
                !serie.metadata.disabled &&
                !serie.metadata.removed
            ) {
                return points[serie._id][date];
            }

            points[serie._id][date] = total;

            return total;
        };

        const seriesList = series.filter(
            (s) => s.level === "0" && !s.metadata.disabled && !s.removed
        );
        if (seriesList.length) {
            const allDates = Object.keys(points[seriesList[0]._id]);
            seriesList.forEach((serie) => {
                allDates.forEach((date) => {
                    _recursiveCalculate(serie, date, series);
                });
            });
        }

        return points;
    }

    _generateYears(startYear, endYear) {
        return Array.from(
            { length: endYear - startYear + 1 },
            (_, i) => startYear + i
        );
    }
}
